import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Role } from "../models/Role";
import { AuthenticationService } from "./authentication.service";

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree {
    const currentUser = this.authenticationService.currentUserValue;
    if (currentUser) {
      const userRoles = currentUser.roles || [];
      if (route.data['roles'] && userRoles.length > 0 && route.data['roles'].indexOf(userRoles[0]) === -1) {
        if (userRoles[0] === Role.Admin) {
          return this.router.parseUrl('/admin-panel/admin-dashboard');
        } else if (userRoles[0] === Role.User) {
          return this.router.parseUrl('/editor-panel/editor-dashboard');
        } else if (userRoles[0] === Role.Coach) {
          return this.router.parseUrl('/admin-panel/admin-coach-applications');
        } else {
          return this.router.parseUrl('/');
        }
      }
      return true;
    }
    return this.router.createUrlTree(['/'], { queryParams: { returnUrl: state.url } });
  }
}
